import {
  ColumnBlockModel,
  ColumnsBlockModel,
  ParagraphBlockModel,
} from '@blocksuite/affine-model';
import {
  matchModels,
  pruneEmptyColumns,
} from '@blocksuite/affine-shared/utils';
import { KeymapExtension, TextSelection } from '@blocksuite/std';

/**
 * Backspace at the start of the only (empty) paragraph of a column removes
 * that column. Removing the last column unwraps the remaining content back
 * into the note and deletes the container.
 */
export const ColumnsKeymapExtension = KeymapExtension(std => {
  return {
    Backspace: ctx => {
      const text = std.selection.find(TextSelection);
      if (!text || !text.isCollapsed() || text.from.index !== 0) return false;

      const block = std.store.getBlock(text.from.blockId);
      if (!block) return false;
      if (!matchModels(block.model, [ParagraphBlockModel])) return false;
      if ((block.model.text?.length ?? 0) !== 0) return false;

      const column = std.store.getParent(block.model);
      if (!column || !matchModels(column, [ColumnBlockModel])) return false;
      if (column.children.length !== 1) return false;

      const columns = std.store.getParent(column);
      if (!columns || !matchModels(columns, [ColumnsBlockModel])) return false;

      ctx.get('defaultState').event.preventDefault();

      std.store.deleteBlock(column);
      pruneEmptyColumns(std.store, columns);

      return true;
    },
  };
});
